import React, { PureComponent, Fragment } from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { DownOutlined, SettingOutlined } from '@ant-design/icons';
import { Menu, Spin, Divider, Modal, Row, Col, Popconfirm, Tooltip, Input, Empty } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import Link from 'umi/link';
import classNames from 'classnames';
import { isSuperAdmin, userCan } from '@/utils/authority';
import CreateOrgForm from './CreateOrgForm';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import { currentUser, currentUserDetail } from '../../services/user';
import CreateOrgAlertModal from './CreateOrgAlertModal';
import { PATH_DASHBOARD } from '@/utils/routes/path';

const { Search } = Input;

@connect(
  ({
    organisation,
    cloudAccount,
    integrations,
    customRegulations,
    user,
    universalDrawer,
    billingDashboard,
  }) => ({
    currentOrganisation: organisation.current,
    cloudAccount,
    universalDrawer,
    userRole: user.authority,
    integrations,
    customRegulations,
    user: user.currentUser,
    organisationsList: organisation.list,
    loading: organisation.loading,
    loadingCurrent: organisation.loadingCurrent,
    packageExpiry: organisation.packageExpiry,
    currentPackageLimitations: organisation.currentPackageLimitations,
  })
)
export default class SelectOrganisation extends PureComponent {
  state = {
    showCreateOrg: false,
    hideCancel: false,
    isModalVisible: false,
    allOrganizationsList: [],
    filteredOrganizations: [],
    searchValue: '',
  };

  // this function will check is user allowed to create an organization
  isAllowedToCreateAnOrganization = () => {
    const { currentPackageLimitations, user } = this.props;

    if (user?.organisations?.length < currentPackageLimitations?.totalNoOfOrganizations) {
      this.changeHandle('create');
    } else {
      this.setState({
        isModalVisible: true,
      });
    }
  };

  changeHandle = orgId => {
    // It wouldn't redirect to edit cloud account page
    if (window.location.href.includes(`${PATH_DASHBOARD.setup.cloudAccountsEdit}?cloudaccount`)) {
      router.push(PATH_DASHBOARD.setup.cloudAccounts);
    }

    this.getUser();
    const { dispatch, currentOrganisation } = this.props;
    if (orgId === 'create') {
      this.setState({
        showCreateOrg: true,
      });
      return;
    }
    dispatch({
      type: 'organisation/setById',
      payload: orgId,
    });
    dispatch({
      type: 'CANCEL_WATCH/cloudAccount',
    });

    dispatch({
      type: 'cloudAccount/clearSelected',
    });
    dispatch({
      type: 'customRegulations/getCustomRegulation',
      payload: {
        force: true,
      },
    });
    dispatch({
      type: 'billingDashboard/list',
      payload: {
        params: {
          orgId: orgId,
        },
      },
    });
    dispatch({
      type: 'universalDrawer/clear',
    });
  };

  onClickEditOrg = e => {
    e.stopPropagation();
    router.push(PATH_DASHBOARD.setup.settings.accessControl);
  };

  changeShowCreateOrg = showCreateOrg => this.setState({ showCreateOrg });

  handleCancel = e => {
    this.setState({ showCreateOrg: false });
  };

  componentDidMount() {
    this.getUser();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user.organisations !== this.props.user.organisations) {
      this.getUser();
    }
    if (prevProps.currentOrganisation !== this.props.currentOrganisation) {
      this.getUser();
    }
    if (prevProps.user.organisations.length !== this.props.user.organisations.length) {
      this.getUser();
    }
    if (
      prevProps?.user?.organisations.length > 0 &&
      this.props?.user?.organisations.length === 0 &&
      this.props?.user?.Role === 'PARENT_USER'
    ) {
      this.setState({
        showCreateOrg: true,
        hideCancel: true,
      });
    }
  }

  getUser = async () => {
    const res = await currentUserDetail();
    if (res) {
      let organizationData = await res.data();
      if (organizationData?.Role === 'CHILD_USER' && organizationData?.organisations.length === 0) {
        window.location.reload(true);
      }
      const { organisationsList } = this.props;
      const listOfOrganizations =
        organizationData &&
        organizationData.organisations &&
        organizationData.organisations.map(eachOrganisation => {
          let orgName = organisationsList.find(eachOrg => {
            return eachOrg.id === eachOrganisation ? eachOrg.name : '';
          });
          name =
            orgName && orgName.name
              ? orgName.name
              : eachOrganisation.substr(0, eachOrganisation.lastIndexOf('_'));
          return { id: eachOrganisation, name: name };
        });

      // checking if there's any search text so dont overwrite the array and keep the filtered Organizations
      // when it'll run for the first time, it'll set the complete array of orgs in the filteredOrganizations because there's no searchVal
      this.setState({
        allOrganizationsList: listOfOrganizations,
        filteredOrganizations: !this.state.searchValue
          ? listOfOrganizations
          : this.state.filteredOrganizations,
      });
    }
  };

  hideModal = params => {
    this.setState({
      isModalVisible: false,
    });
  };

  contactCloudnosys = () => {
    window.open('https://cloudnosys.com/contact/', '_blank');
    this.setState({
      isModalVisible: false,
    });
  };

  searchOrganization(value) {
    const { allOrganizationsList } = this.state;
    if (allOrganizationsList === null) {
      return <Spin />;
    }
    if (value.target.value === '') {
      this.setState({
        filteredOrganizations: allOrganizationsList,
      });
      return;
    }

    const searchOrganizations = allOrganizationsList.filter(val =>
      val.name.toLowerCase().includes(value.target.value.toLowerCase())
    );

    if (searchOrganizations.length === 0) {
      this.setState({
        filteredOrganizations: [],
      });
      return;
    }
    this.setState({
      searchValue: value.target.value,
      filteredOrganizations: searchOrganizations,
    });
  }

  isOrgExpired = currentOrg => {
    if (currentOrg) {
      const endTimestamp = currentOrg.package.end.toDate();
      const currentTimestamp = new Date();
      return currentTimestamp > endTimestamp;
    }
    return false;
  };

  render() {
    const {
      loading,
      loadingCurrent,
      className,
      currentOrganisation,
      organisationsList,
      isMobile,
      user,
      packageExpiry,
      userRole,
    } = this.props;

    let { hideCancel, isModalVisible, allOrganizationsList, filteredOrganizations } = this.state;

    filteredOrganizations =
      filteredOrganizations.length > 0
        ? filteredOrganizations.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          )
        : [];

    const selectionMenu = (
      <Menu
        style={{
          borderRadius: '8px',
        }}
        className={styles.menu}
        selectedKeys={[currentOrganisation ? currentOrganisation.id : '']}
      >
        <Search
          placeholder="Search for an Organization"
          onChange={value => this.searchOrganization(value)}
          onSubmit={() => {}}
          onDoubleClick={() => {}}
          autoFocus
          allowClear
          style={{ width: '95%', margin: '2px 10px 10px 10px' }}
        />
        <div style={{ maxHeight: 300, overflow: 'auto' }}>
          {filteredOrganizations &&
          Array.isArray(filteredOrganizations) &&
          filteredOrganizations.length > 0 ? (
            <>
              {filteredOrganizations.map(item => {
                let isCurrentOrg = false;
                if (currentOrganisation) {
                  isCurrentOrg = item.id === currentOrganisation.id;
                }
                // ? if type of any org is deleted so that org is not present in the organisationsList
                // Below function search in the organisationsList and if item.id is not present in organisationsList so it filters out
                let isDeletedOrg = this.props.organisationsList.some(organisation => {
                  return item.id === organisation.id;
                });
                if (!isDeletedOrg) return;

                return (
                  <Menu.Item
                    key={item.id}
                    value={item}
                    style={{
                      background: 'white',
                    }}
                  >
                    <Row>
                      <Col span={23} onClick={() => !isCurrentOrg && this.changeHandle(item.id)}>
                        <Tooltip placement="top" title={item && item.name}>
                          <span style={{ fontWeight: isCurrentOrg ? 'bold' : 'normal' }}>
                            {item && item.name.length > 30
                              ? item.name.substring(0, 30).concat('...')
                              : item.name}
                          </span>
                        </Tooltip>
                      </Col>
                      {userCan('update-organisation') && (
                        <Col span={1}>
                          <SettingOutlined onClick={this.onClickEditOrg} type="edit" />
                        </Col>
                      )}
                    </Row>
                  </Menu.Item>
                );
              })}
            </>
          ) : (
            <Empty className="mt-2 mb-3" description="No data" />
          )}
        </div>

        {userCan('create-organisation') &&
          !this.isOrgExpired(currentOrganisation && currentOrganisation) && (
            <Menu.Item onClick={() => this.isAllowedToCreateAnOrganization()}>
              Create an organization
            </Menu.Item>
          )}
      </Menu>
    );

    const orgModalProps = {
      isModalVisible: isModalVisible,
      hideModal: this.hideModal,
      contactCloudnosys: this.contactCloudnosys,
    };

    return (
      <Fragment>
        <CreateOrgAlertModal {...orgModalProps} />
        <HeaderDropdown
          overlay={selectionMenu}
          placement="bottomRight"
          overlayStyle={{ width: 300 }}
        >
          <div
            style={{
              marginLeft: 25,
              borderRight: '1px solid #d9d9d9',
              borderLeft: '1px solid #d9d9d9',
            }}
            className={classNames(styles.dropDown, className)}
          >
            <div style={{ paddingLeft: 15, paddingRight: 15 }}>
              <div
                style={{
                  fontSize: '12px',
                  color: '#9B9B9B',
                  marginTop: '-10px',
                  marginBottom: '-46px',
                }}
              >
                Organization <DownOutlined className={styles.dropdownIcon} />
              </div>

              <div style={{ fontSize: '16px', fontWeight: 500 }}>
                <Tooltip placement="top" title={currentOrganisation && currentOrganisation.name}>
                  {currentOrganisation?.name
                    ? currentOrganisation.name.length > 20
                      ? currentOrganisation.name.substring(0, 20).concat('...')
                      : currentOrganisation.name
                    : ''}
                </Tooltip>
              </div>
            </div>
          </div>
        </HeaderDropdown>

        <CreateOrgForm
          hideCancel={hideCancel}
          showCreateOrg={this.state.showCreateOrg}
          mode="add"
          afterClose={() => this.changeShowCreateOrg(false)}
        />
      </Fragment>
    );
  }
}
